// extracted by mini-css-extract-plugin
export var bodySections = "_bx-8";
export var gray = "_bx-7";
export var green = "_bx-4";
export var iconContainer = "_bx-9";
export var iconWidgetContainer = "_bx-1";
export var phoneIcon = "_bx-2";
export var red = "_bx-5";
export var statusDot = "_bx-3";
export var widgetContainer = "_bx-0";
export var yellow = "_bx-6";